module.exports = __webpack_public_path__ + "img/not-authorized.163d16f4.svg";